import React from 'react'
import Navbar from './Navbar'
import { useLocation } from 'react-router-dom'

function Dashboard() {


  return (
    <div>
      <Navbar></Navbar>
      <h1>dashboard</h1>
      <h3></h3>
    </div>
  )
}

export default Dashboard
